import { menuListStore } from '@/store/menuListStore';
import { chatStore } from '@/store/chatStore';
import { checkVersion } from './checkVersion';
import { isWechatBrowser, isProd } from '@/lib/utils';
import { rootStore } from '@/store/rootStore';

declare global {
  interface Window {
    platformData: any;
    LINGHIT_APM_SDK: any;
    qaSDKInstance: any;
  }
}
let routerObj: any = null;
const withOutTeamWhiteList = [
  '/login',
  '/mLogin',
  '/404',
  '/resetPassword',
  '/mResetPassword',
  '/mBindAccount',
  '/payment',
  '/webview',
  '/officialToMini',
];
const initRouter = (router: any) => {
  if (router) {
    routerObj = router;
    router.beforeEach((to: any, from: any, next: (arg0?: string) => void) => {
      const rootStoreEx = rootStore();
      // 没有归属团队只允许去设置模块
      if (
        !rootStoreEx.currentUserInfo?.teamId &&
        !to.path?.startsWith('/setting') &&
        !withOutTeamWhiteList.includes(to.path) &&
        !isWechatBrowser
      ) {
        next('/setting');
      } else {
        const store = menuListStore();
        store.setCurrentPath(to.path);
        store.checkExclude(to.name);
        next();
      }
    });

    router.afterEach(() => {
      const store = chatStore();
      if (!isWechatBrowser) {
        store.clearCurrentChatRoomInfo();
      }
      if (isProd) {
        window.platformData && window.platformData.emitHashEvent();
      }
      isProd && !isWechatBrowser && checkVersion();
    });
    router.scrollBehavior = () => ({
      y: 0,
    });
  }
};
function useRouter() {
  return routerObj;
}

export { initRouter, useRouter };
